import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import { MessagePropType, messageToString } from '@ratehub/base-ui';


function ProductName({
    image,
    productName,
    onClick,
    children,
    isNameOnNewLine = false,
    ...otherProps
}) {
    const intl = useIntl();

    return (
        <Container
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? '0' : undefined}
            onClick={onClick}
            imageWidth={image.width}
            imageHeight={image.height || image.width}
            className={classNames('rh-display-flex', 'rh-align-items-flex-start', {
                'rh-flex-direction-column rh-gap-0_5': isNameOnNewLine,
            })}
            {...otherProps}
        >
            <If condition={image}>
                <img
                    className="product-name-logo rh-mr-1"
                    src={image.url}
                    alt={messageToString(image.alt, intl) || ''}
                />
            </If>

            <div className="product-name-title-wrapper">
                <h3 className="product-name-title rh-title-m rh-m-0">
                    {messageToString(productName, intl)}
                </h3>
                {children}
            </div>
        </Container>
    );
}

ProductName.propTypes = {
    image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: MessagePropType,
        width: PropTypes.string.isRequired,
        height: PropTypes.string,
    }),

    productName: MessagePropType.isRequired,
    onClick: PropTypes.func,
    children: PropTypes.any,
    isNameOnNewLine: PropTypes.bool,
};

// div here, but could become an <a>
const Container = styled.div`
    text-decoration: none;

    > .product-name-logo {
        ${({ imageWidth, imageHeight }) => `
            width: ${imageWidth};
            height: ${imageHeight};
        `}
    }

    ${({ href, onClick }) => (href || onClick) && `
        &:hover > .product-name-title-wrapper > .product-name-title {
            text-decoration: underline;
        }
    `}
`;

export default ProductName;
